var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer text_ctr"},[_c('div',{staticClass:"txts"},[_vm._v(" 科技部西南信息中心 · 重庆尚唯信息技术有限公司 联系我们"),_c('br'),_vm._v(" 地址：重庆北部新区黄山大道中段5号水星大厦B座 邮政编码：4011121 免费电话：400-636-0093"),_c('br'),_vm._v(" 增值电信业务经营许可证: 渝B2-20220077"),_c('br'),_vm._v(" 渝ICP备17012494号-1 您的IP地址:014.104.083.222 ")])])
}]

export { render, staticRenderFns }